<template>
    <div class="col-md-6 col-xs-12 matchHeight">
        <div class="innerBox pieWrapper" v-if="!showLoader">
            <div class="pieInnerWrapper">
                <h2>{{ $t('guests') }}</h2>
                <ul data-pie-id="pie-svg">
                    <li v-bind:data-value="getGuestsPercent(guests.notResponded).toString()" class="notResponded"><span><span class="precent">{{ getGuestsPercent(guests.notResponded) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('notResponded') }}</span></span></li>
                    <li v-bind:data-value="getGuestsPercent(guests.coming).toString()" class="respondedPositive"><span><span class="precent">{{ getGuestsPercent(guests.coming) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('willCome') }}</span> {{ $t('toEvent') }}</span></li>
                    <li v-bind:data-value="getGuestsPercent(guests.maybe).toString()" class="respondedMaybe"><span><span class="precent">{{ getGuestsPercent(guests.maybe) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('mayCome') }}</span> {{ $t('willCome') }} {{ $t('toEvent') }}</span></li>
                    <li v-bind:data-value="getGuestsPercent(guests.notComing).toString()" class="respondedNegative"><span><span class="precent">{{ getGuestsPercent(guests.notComing) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('notComing') }}</span> {{ $t('toEvent') }}</span></li>
                    <li v-bind:data-value="getGuestsPercent(guests.reserve).toString()" class="respondedNegative"><span><span class="precent">{{ getGuestsPercent(guests.reserve) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('reserve') }}</span> {{ $t('toEvent') }}</span></li>

                </ul>
            </div>
            <div id="pie-svg"></div>

        </div>
        <div class="innerBoxLoader" v-if="showLoader">
            <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    import Config from '../../Config'
    export default {
        name: "EventGuestsStatistics",
        data(){
            return{
                showLoader:false,
                guests:{
                    notResponded:0,
                    coming:0,
                    maybe:0,
                    reserve:0,
                    notComing:0
                }
            }
        },
        components:{
            RotateLoader
        },
        props:{
            eventData:{
                type:Object,
                default:{hall:{},owner:{},preset:{},presetData:[],guests:[]}
            }
        },
        methods:{
            calculateGuests(){
                if(this.eventData.guests.length > 0 ){
                    let _this = this;
                    this.eventData.guests.forEach((_)=>{
                        _this.guests.notResponded += _.status.notResponded
                        _this.guests.coming += _.status.coming
                        _this.guests.maybe += _.status.maybeComing
                        _this.guests.reserve += _.status.reserve
                        _this.guests.notComing += _.status.notComing
                    })
                }
            },
            getGuestsPercent(sum){
                let _ = Math.round((sum/this.getTotalGuests())*100);
                return isNaN(_) ? 0 : _;
            },
            getTotalGuests(){
                return (this.guests.coming+this.guests.maybe+this.guests.notComing+this.guests.notResponded);
            },
        },
        mounted(){
            this.showLoader = true;
            this.$store.dispatch('getGuests',this.eventData.id)
                .then(response =>{
                    //success
                    this.showLoader = false;
                    this.eventData.guests = response.data;
                    if(!response.data.length) return

                    this.calculateGuests();
                    if((this.guests.coming + this.guests.notResponded + this.guests.notComing + this.guests.maybe) == 0) return
                    this.$emit('initiated',response.data)
                    let _this = this;
                    $.getScript( "/static/js/pie.min.js",function() {
                        $.getScript( "/static/js/dependencies.js",function() {
                            setTimeout(function(){
                                Pizza.init();
                                $(".matchHeight").matchHeight();
                            },300);
                        });
                    });
                })
                .catch(err => {
                    //err
                    this.showLoader = false;
                    this.$router.push('/');
                    this.$swal({
                        confirmButtonText:this.$t('okButton'),
                        type:'error',
                        title:this.$t('fatalError'),
                        timer:3000
                    }).catch(this.$swal.noop);
                })
        }
    }
</script>
<style scoped>
    .pieWrapper .pieInnerWrapper{
        width:50%;
        float: right;
    }

    .pieWrapper #pie-svg{
        width:50%;
        float: right;
    }

    [data-pie-id] > *:nth-child(7n+1), [data-bar-id] > *:nth-child(7n+1), [data-line-id] > *:nth-child(7n+1) {
        color: #293b5a; }
    [data-pie-id] > *:nth-child(7n+2), [data-bar-id] > *:nth-child(7n+2), [data-line-id] > *:nth-child(7n+2) {
        color: #465a7f; }
    [data-pie-id] > *:nth-child(7n+3), [data-bar-id] > *:nth-child(7n+3), [data-line-id] > *:nth-child(7n+3) {
        color: #5e769f; }
    [data-pie-id] > *:nth-child(7n+4), [data-bar-id] > *:nth-child(7n+4), [data-line-id] > *:nth-child(7n+4) {
        color: #7792bf; }



    #pie, #donut, #bar {
        max-height: 450px; }


    svg {
        width: 100%;
        height: auto;
    }


    ul[data-pie-id] {
        list-style: none;
    }
    .pieWrapper ul li{
        font-size:1.118rem;
    }
    .pieWrapper ul li + li{
        margin-top:10px;
    }
    .pieWrapper ul li span{
        color:#2e2e2e;
    }
    .pieWrapper ul li span span{
        font-weight: 700;
        font-style: italic;
    }
    .pieWrapper ul li:before{
        content: "";
        width:17px;
        height:17px;
        border-radius: 50%;
        display:inline-block;
        margin-top:2px;
        margin-left:15px;

    }
    .pieWrapper .pieInnerWrapper{
        padding:0 30px;
    }
    .pieWrapper .pieInnerWrapper h2{

        margin:20px 0px;

    }
    .pieWrapper ul li.notResponded:before{background:#5e769f;}
    .pieWrapper ul li.respondedPositive:before{background:#465a7f;}
    .pieWrapper ul li.respondedMaybe:before{background:#7792bf;}
    .pieWrapper ul li.respondedNegative:before{background:#293b5a;}

    .pieWrapper ul li.notResponded span .status{color:#5e769f;}
    .pieWrapper ul li.respondedPositive span .status{color:#465a7f;}
    .pieWrapper ul li.respondedMaybe span .status{color:#7792bf;}
    .pieWrapper ul li.respondedNegative span .status{color:#293b5a;}
</style>
